import { z } from 'zod'

import { enter } from '@/shared/lib'

import type { CreateUserNotePayload } from '../api'

export const userNoteSchema = z.object({
  text: z.string().trim().min(1, enter('a note')),
  notifyAt: z.string().nullable()
})

export type UserNoteForm = z.infer<typeof userNoteSchema>

export const userNoteFormInitial = (): UserNoteForm => ({
  text: '',
  notifyAt: null
})

export function buildCreateUserNotePayload(
  form: UserNoteForm
): CreateUserNotePayload {
  return {
    text: form.text.trim(),
    notifyAt: form.notifyAt
  }
}
